export const SENDING_REQUEST = 'PROJECTSFORM_SENDING_REQUEST';
export const CREATE_SUCCESS = 'PROJECTSFORM_CREATE_SUCCESS';
export const UPDATE_SUCCESS = 'PROJECTSFORM_UPDATE_SUCCESS';
export const FAILURE = 'PROJECTSFORM_FAILURE';
export const RESET_FORM = 'PROJECTSFORM_RESET_FORM';
export const VALUE_CHANGED = 'PROJECTSFORM_VALUE_CHANGED';